import "core-js/modules/es.array.includes";
import "core-js/modules/es.object.define-property";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.includes";
import { __awaiter, __decorate, __extends, __generator } from "tslib";
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

var OrderInfo = function (_super) {
  __extends(OrderInfo, _super);

  function OrderInfo() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.orderDetail = {};
    return _this;
  }

  OrderInfo.prototype.onCodeChange = function (code) {
    if (code) {
      this.queryOrderDetail();
    }
  };

  OrderInfo.prototype.queryOrderDetail = function () {
    return __awaiter(this, void 0, Promise, function () {
      var data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, this.$api.order.queryDetail({
              code: this.code,
              is_gd: this.$enum.common.BoolIntEnum.NO
            })];

          case 1:
            data = _a.sent().data;
            this.orderDetail = data.ods_order;
            return [2];
        }
      });
    });
  };

  Object.defineProperty(OrderInfo.prototype, "isViewInsuranceValue", {
    get: function get() {
      var _a, _b;

      var insuranceCompanyList = ((_a = this.orderDetail.value_added_service) === null || _a === void 0 ? void 0 : _a.insurance_company_list) || [];
      var isServiceProvider = insuranceCompanyList.includes(this.$enum.claims.InsuranceCompanyEnum.SERVICE_PROVIDER);
      var insuranceValue = ((_b = this.orderDetail.value_added_service) === null || _b === void 0 ? void 0 : _b.insurance_value) || 0;
      return +insuranceValue > 0 && isServiceProvider;
    },
    enumerable: false,
    configurable: true
  });

  __decorate([Prop({
    type: String,
    "default": ''
  })], OrderInfo.prototype, "code", void 0);

  __decorate([Watch('code', {
    immediate: true
  })], OrderInfo.prototype, "onCodeChange", null);

  OrderInfo = __decorate([Component], OrderInfo);
  return OrderInfo;
}(Vue);

export default OrderInfo;